var _path, _path2, _rect, _polygon, _polygon2, _rect2, _rect3, _line, _ellipse, _path3, _polyline, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120.2 125.4",
    enableBackground: "new 0 0 120.2 125.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5581C1",
    d: "M112.3,46.7c-6.6-23.3-29.3-41.2-54-38.4c-0.1-0.2-0.3-0.2-0.6-0.2C35.1,10.4,16.6,26.7,9.8,48 c-0.9,2.7-1.5,5.4-2.1,8.2c-0.2,0.1-0.3,0.4-0.1,0.5c-0.2,1-0.3,2-0.4,3c-0.1,0.1-0.1,0.2,0,0.3c-0.9,7.3-0.5,14.8,1.5,21.8 c0.8,2.9,2,5.6,3.4,8.1c0,0.2,0.1,0.4,0.3,0.5c3.8,6.5,9.4,11.8,15.9,16.1c9.8,6.4,20.5,10.8,32.3,10.7c1.3,0,2.6-0.1,3.9-0.2 c0.2,0.2,0.7,0.2,0.8-0.1c9-0.8,17.7-3.9,25.3-8.6c9.9-6.2,17.1-14.5,20.7-25.6C115,71.1,115.7,58.4,112.3,46.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.4315,
    y1: 59.408,
    x2: 116.017,
    y2: 91.1961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1485,
    style: {
      stopColor: "#1C477A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1694,
    style: {
      stopColor: "#1E497C",
      stopOpacity: 0.9892
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6759,
    style: {
      stopColor: "#456FAC",
      stopOpacity: 0.7283
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9251,
    style: {
      stopColor: "#5581C1",
      stopOpacity: 0.6
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M114.2,56.7L76.8,29.8L37.9,96.1L74,115.5c4.8-1.5,12.3-4.4,16.6-7.1c9.9-6.2,17.1-14.5,20.7-25.6 C113.1,77.1,114.5,64.6,114.2,56.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 55.6,
    transform: "matrix(1.523329e-02 -0.9999 0.9999 1.523329e-02 -16.7453 122.333)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 52.5,
    height: 28.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 76.8,35.3 80.6,41.3 79.9,91.5 67.4,96.2 68.2,43.6 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 48.5,34.8 40.1,43.2 68.2,43.6 76.8,35.3 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60.2,
    y: 18.4,
    transform: "matrix(1.523329e-02 -0.9999 0.9999 1.523329e-02 29.1788 94.745)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 5,
    height: 28.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.7,
    y: 51.7,
    transform: "matrix(0.9999 1.523329e-02 -1.523329e-02 0.9999 0.961 -0.8105)",
    fill: "none",
    stroke: "#5581C1",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 22,
    height: 22
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5581C1",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 42.4,
    y1: 78,
    x2: 64.5,
    y2: 78.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9844 -0.1758 0.1758 0.9844 -6.0413 10.7284)",
    fill: "none",
    stroke: "#5581C1",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 57.5,
    cy: 39.5,
    rx: 3,
    ry: 1.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5581C1",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M57.9,64.5c0,2.3-1.9,4.2-4.3,4.1c-2.3,0-4.2-1.9-4.1-4.3c0-2.3,4.3-7.6,4.3-7.6S57.9,62.2,57.9,64.5z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#5581C1",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 39.1,44.2 67.2,44.6 75.8,36.3 "
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5581C1",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 67.4,
    y1: 96.2,
    x2: 67.2,
    y2: 44.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilkIcon);
export default __webpack_public_path__ + "static/media/milk_icon.fd74bf041f7826065a491391c558e0a7.svg";
export { ForwardRef as ReactComponent };